module.exports = __webpack_public_path__ + "static/media/33.38620196.jpg";